import { Typo } from "../../Typo";

import type { MarketingBannerSize } from "./types";

type SizeSelectionCardProps = {
  size: MarketingBannerSize;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const SizeSelectionCard = ({
  size,
  selected,
  disabled = false,
  onClick,
}: SizeSelectionCardProps) => {
  const aspect = size.width / size.height;
  const maxIconBoxWidth = 24;
  const maxIconBoxHeight = 16;
  let iconWidth: number;
  let iconHeight: number;
  if (aspect >= maxIconBoxWidth / maxIconBoxHeight) {
    iconWidth = maxIconBoxWidth;
    iconHeight = Math.max(3, Math.round(maxIconBoxWidth / aspect));
  } else {
    iconHeight = maxIconBoxHeight;
    iconWidth = Math.max(3, Math.round(maxIconBoxHeight * aspect));
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={`flex w-[71px] flex-col items-center justify-center gap-2 rounded-lg px-3 pb-2 pt-3 transition-colors ${
        disabled
          ? "cursor-not-allowed bg-surface-secondary opacity-40"
          : selected
            ? "bg-surface-inverse-primary"
            : "bg-surface-secondary hover:bg-surface-tonal-bold"
      }`}
    >
      <div className="flex h-4 w-full items-center justify-center">
        <div
          style={{ width: iconWidth, height: iconHeight }}
          className={`outline outline-[1.5px] ${
            selected ? "outline-text-inverse-primary" : "outline-icon-primary"
          }`}
        />
      </div>
      <Typo
        type="bodyXS"
        textColor={selected ? "text-text-inverse-primary" : "text-text-primary"}
      >
        {size.label}
      </Typo>
    </button>
  );
};
